import { Component, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.css']
})
export class MessageBoxDialog {

  message: any[];
  html: string;

  constructor(public dialogRef: MdDialogRef<MessageBoxDialog>,
    @Inject(MD_DIALOG_DATA) public data: any) {
      if (data.html) {
        this.html = data.html;
      } else {
        try {
          this.message = [];
          const jsonError = JSON.parse(data.message);
          for (const key in jsonError) {
            this.message.push ({message : jsonError[key]});
          }
        } catch (e) {
          this.message.push ({message: data.message});
        }
      }
    }
}


// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/message-box/message-box.component.ts